import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { UsersService } from '../data/users.service';

import { Store, select } from '@ngrx/store';
import { selectUserId } from '../auth/store/auth.selectors';
import { AppState } from '../core.module';
import { User } from '../models/user.model';

interface AppSettings {
  appFavourites?: number[];
}

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService implements OnDestroy {
  private unsubscribe$ = new Subject<void>();

  myId = 0;
  user: User;

  settings: BehaviorSubject<AppSettings>;

  constructor(
    private store: Store<AppState>,
    private _usersService: UsersService
  ) {
    this.settings = new BehaviorSubject<AppSettings>({});

    this.store
      .pipe(select(selectUserId))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((id: string) => {
        this.myId = +id;
        this._usersService
          .get(this.myId)
          .pipe(take(1))
          .subscribe(user => {
            this.user = user;
            this.settings.next(JSON.parse(user.uiSettings || '{}'));
            if (!this.settings.value.appFavourites) {
              const settings = this.settings.value;
              settings.appFavourites = [];
              this.settings.next(settings);
            }
          });
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getSettings() {
    return this.settings;
  }

  saveSettings(settings: AppSettings) {
    this.user.uiSettings = JSON.stringify(settings);
    this._usersService
      .edit(this.user)
      .pipe(take(1))
      .subscribe(() => {
        this.settings.next(settings);
      });
  }

  toggleAppFavourite(appId: number): number[] {
    if (this.settings) {
      const settings = this.settings.value;
      if (settings.appFavourites) {
        if (!settings.appFavourites.includes(appId))
          settings.appFavourites.push(appId);
        else {
          const index = settings.appFavourites.indexOf(appId);
          settings.appFavourites.splice(index, 1);
        }
      } else {
        settings.appFavourites = [appId];
      }
      this.saveSettings(settings);
      return settings.appFavourites;
    } else {
      return [];
    }
  }
}
